import type { ReactNode } from 'react';
import { styled } from 'styled-components';

import { BodySmall } from '#/components/Text/BodySmall';
import { RichTextHeadline } from '#/components/Text/RichTextHeadline';

import {
  SearchHitCarouselHeader_Box_1,
  SearchHitCarouselHeader_Box_2,
} from './SearchHitCarouselHeader.styled';

type HeaderProps = {
  layout: 'SLIM' | 'REGULAR';
  headline: string | null | undefined;
  linkNode: ReactNode | null | undefined;
};
const SlimRichTextHeadline = styled(RichTextHeadline)`
  h2 {
    margin: 0 !important;
  }

  h2::before {
    display: none !important;
  }
`;

export function SearchHitCarouselHeader({
  layout,
  headline,
  linkNode,
}: HeaderProps) {
  if (layout === 'REGULAR')
    return (
      <>
        {headline && (
          <RichTextHeadline textAlignCenter>{headline}</RichTextHeadline>
        )}

        {linkNode && (
          <SearchHitCarouselHeader_Box_2>
            <BodySmall style={{ marginBottom: 20 }}>{linkNode}</BodySmall>
          </SearchHitCarouselHeader_Box_2>
        )}
      </>
    );

  return (
    <SearchHitCarouselHeader_Box_1>
      {headline && <SlimRichTextHeadline>{headline}</SlimRichTextHeadline>}

      <BodySmall>{linkNode}</BodySmall>
    </SearchHitCarouselHeader_Box_1>
  );
}
